import { render } from "./showOrder.vue?vue&type=template&id=0c64663f&scoped=true"
import script from "./showOrder.vue?vue&type=script&lang=js"
export * from "./showOrder.vue?vue&type=script&lang=js"

import "./showOrder.vue?vue&type=style&index=0&id=0c64663f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c64663f"]])

export default __exports__